<script>
import AdaptsRelateFieldtype from './AdaptsRelateFieldtype.vue';

export default {

    mixins: [AdaptsRelateFieldtype]

};
</script>



// WEBPACK FOOTER //
// CollectionFieldtype.vue?bf2afb84